<div class="content-detail">
  <div class="header-container">
    <h2>{{ "master-tenant.title" | translate }}</h2>
    <button mat-raised-button color="primary" (click)="openAddDialog()">
      {{ "master-tenant.addNewTenant" | translate }}
    </button>
  </div>
  <div class="table-content">
    <table class="table table-bordered text-center">
      <thead>
        <tr>
          <th>{{ "master-tenant.activeStatus" | translate }}</th>
          <th>{{ "master-tenant.tenantName" | translate }}</th>
          <th>{{ "master-tenant.aka" | translate }}</th>
          <th>{{ "master-tenant.subIndustry" | translate }}</th>
          <!--           <th>{{ "master-tenant.country" | translate }}</th>
          <th>{{ "master-tenant.contact" | translate }}</th> -->
          <th>{{ "master-tenant.tenantStatus" | translate }}</th>
          <th *ngIf="currentCode == 'mx'">
            {{ "master-tenant.tag" | translate }}
          </th>
          <th>{{ "master-tenant.dateCreated" | translate }}</th>
          <th>{{ "master-tenant.upadateCreated" | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <select
              [(ngModel)]="filterActiveStatus"
              (change)="onInputChange()"
              class="form-select margin-filter"
            >
              <option [ngValue]="null"></option>
              <option [ngValue]="'Active'"
                >{{ "master-tenant.active" | translate }}
              </option>
              <option [ngValue]="'Inactive'">{{
                "master-tenant.inactive" | translate
              }}</option>
              <option [ngValue]="'Pending'">{{
                "master-tenant.pending" | translate
              }}</option>
              <option [ngValue]="'InactiveMerged'">{{
                "master-tenant.inactiveMerged" | translate
              }}</option>
            </select>
          </td>
          <td>
            <input
              type="text"
              [(ngModel)]="filterName"
              (ngModelChange)="onInputChange()"
              [placeholder]="'master-tenant.filterByName' | translate"
              class="form-control margin-filter"
            />
          </td>
          <td></td>
          <td>
            <select
              [(ngModel)]="filterIndustry"
              (change)="onInputChange()"
              class="form-select margin-filter"
            >
              <option [ngValue]="null">{{
                "master-tenant.industryOption" | translate
              }}</option>
              <option *ngFor="let industry of industries" [value]="industry.id"
                >{{ industry.name | langSelector }}
              </option>
            </select>
          </td>
          <!-- <td>
            <select
              [(ngModel)]="filterCountry"
              (change)="onInputChange()"
              class="form-select margin-filter"
            >
              <option [ngValue]="null">{{
                "master-tenant.industryOption" | translate
              }}</option>
              <option [ngValue]="''">{{
                "master-tenant.none" | translate
              }}</option>
              <option *ngFor="let country of countries" [value]="country">{{
                country
              }}</option>
            </select>
          </td>
          <td>
            <select
              [(ngModel)]="filterContact"
              (change)="onInputChange()"
              class="form-select margin-filter"
            >
              <option [ngValue]="null">{{
                "master-tenant.industryOption" | translate
              }}</option>
              <option [ngValue]="true"
                >{{ "master-tenant.yes" | translate }}
              </option>
              <option [ngValue]="false">{{
                "master-tenant.no" | translate
              }}</option>
            </select>
          </td> -->
          <td>
            <select
              [(ngModel)]="filterStatus"
              (change)="onInputChange()"
              class="form-select margin-filter"
            >
              <option [ngValue]="null">{{
                "master-tenant.industryOption" | translate
              }}</option>
              <option [ngValue]="true"
                >{{ "master-tenant.stats" | translate }}
              </option>
              <option [ngValue]="false">{{
                "master-tenant.noStats" | translate
              }}</option>
            </select>
          </td>
          <td *ngIf="currentCode == 'mx'">
            <select
              class="form-select margin-filter"
              (change)="onInputChange()"
              [(ngModel)]="filterParentCorporationValue"
            >
              <option
                *ngFor="let parentCorporationValue of parentCorporationList"
                [value]="parentCorporationValue"
              >
                {{ "PROPERTY_TYPES." + parentCorporationValue | translate }}
              </option>
            </select>
          </td>
          <td style="overflow: visible;">
            <div class="position-relative combo-wrapper">
              <input
                type="text"
                class="form-control"
                [placeholder]="'master-tenant.filterByDate' | translate"
                (focus)="showDropdown = true"
                (blur)="hideDropdown()"
                [(ngModel)]="filterDateOptions.year"
                (ngModelChange)="onInputChange()"
                (input)="filterNumericInput($event)"
              />
              <ul
                class="dropdown-menu show"
                *ngIf="showDropdown"
                style="width: 100%;"
              >
                <li>
                  <a
                    class="dropdown-item"
                    (mousedown)="toggleQuarter('thisQuarter')"
                  >
                    <input
                      type="checkbox"
                      [checked]="filterDateOptions.thisQuarter"
                    />
                    {{ "master-tenant.thisQuarter" | translate }}
                  </a>
                </li>
                <li>
                  <a
                    class="dropdown-item"
                    (mousedown)="toggleQuarter('lastQuarter')"
                  >
                    <input
                      type="checkbox"
                      [checked]="filterDateOptions.lastQuarter"
                    />
                    {{ "master-tenant.lastQuarter" | translate }}
                  </a>
                </li>
              </ul>
            </div>
          </td>
          <td style="overflow: visible;">
            <div class="position-relative combo-wrapper">
              <input
                type="text"
                class="form-control"
                [placeholder]="'master-tenant.filterByDate' | translate"
                (focus)="showDropdownModifiedDate = true"
                (blur)="hideDropdownModifiedDate()"
                [(ngModel)]="filterModifiedDateOptions.yearModifiedDate"
                (ngModelChange)="onInputChangeModifiedDate()"
                (input)="filterNumericInputModifiedDate($event)"
              />
              <ul
                class="dropdown-menu show"
                *ngIf="showDropdownModifiedDate"
                style="width: 100%;"
              >
                <li>
                  <a
                    class="dropdown-item"
                    (mousedown)="
                      toggleQuarterModifiedDate('thisQuarterModifiedDate')
                    "
                  >
                    <input
                      type="checkbox"
                      [checked]="
                        filterModifiedDateOptions.thisQuarterModifiedDate
                      "
                    />
                    {{ "master-tenant.thisQuarter" | translate }}
                  </a>
                </li>
                <li>
                  <a
                    class="dropdown-item"
                    (mousedown)="
                      toggleQuarterModifiedDate('lastQuarterModifiedDate')
                    "
                  >
                    <input
                      type="checkbox"
                      [checked]="
                        filterModifiedDateOptions.lastQuarterModifiedDate
                      "
                    />
                    {{ "master-tenant.lastQuarter" | translate }}
                  </a>
                </li>
              </ul>
            </div>
          </td>
        </tr>

        <tr *ngFor="let tenant of tenants">
          <td>
            {{
              tenant?.status == "Active"
                ? ("master-tenant.active" | translate)
                : tenant?.status == "Inactive"
                ? ("master-tenant.inactive" | translate)
                : tenant?.status == "InactiveMerged"
                ? ("master-tenant.inactiveMerged" | translate)
                : ("master-tenant.pending" | translate)
            }}
          </td>
          <td class="align-column">
            <mat-icon (click)="editTenant(tenant)">edit</mat-icon>
            <span>{{ tenant?.name }}</span>
          </td>
          <td>
            {{ tenant?.aka }}
          </td>
          <td>{{ tenant?.industry?.name | langSelector }}</td>
          <!-- <td>{{ tenant?.country }}</td>
          <td>
            {{
              validateContact(tenant)
                ? ("master-tenant.yes" | translate)
                : ("master-tenant.no" | translate)
            }}
          </td> -->
          <td>
            {{
              tenant?.includedInStats
                ? ("master-tenant.stats" | translate)
                : ("master-tenant.noStats" | translate)
            }}
          </td>
          <td *ngIf="currentCode == 'mx'">
            {{ tenant?.corporationPropertyType }}
          </td>
          <td>{{ tenant?.createdDate }}</td>
          <td>{{ tenant?.modifiedDate }}</td>
        </tr>
      </tbody>
    </table>
    <ngb-pagination
      [collectionSize]="total"
      [(page)]="page"
      [pageSize]="perPage"
      [maxSize]="5"
      (pageChange)="onPageChange($event)"
    ></ngb-pagination>
  </div>
</div>
